import { render } from "./privacyVue.vue?vue&type=template&id=b207d542&lang=true"
import script from "./privacyVue.vue?vue&type=script&lang=js"
export * from "./privacyVue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__